import request from '@/plugin/axios'
import { cookieGet } from '@/common/cookie'



export const upload_pictureofsystem = process.env.VUE_APP_API + '/common/v1/upload/pictureofsystem'

export const upload_videoofsystem = process.env.VUE_APP_API + '/v1/upload/videoofsystem'

export const upload_apk = process.env.VUE_APP_API + '/v1/upload/apk'
export const upload_file = process.env.VUE_APP_API + '/common/v1/upload/uploadFile'

/**
 * @description [ sys ] 登陆注销相关
 */
export const sysAccountService = {
  /**
   * 登录
   */
  login(data) {
    return request({
      url: '/manager/Admin/loginByUserName',
      method: 'post',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data
    })
  },
  /**
   * 登录
   */
  b2blogin(data) {
    return request({
      url: '/b2b/account/loginByUserName2',
      method: 'post',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data
    })
  },
  verifyImage(data) {
    return request({
      url: '/b2b/account/verifyImage',
      method: 'post',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      data
    })
  }
}
/**
 * @description [ sys ] 修改密码
 */
export const sysUserService = {
  /**
   * 修改密码
   */
  updatePassword(data) {
    return request({
      url: '/manager/Admin/resetPassword',
      method: 'post',
      data
    })
  },
  BupdatePassword(data) {
    return request({
      url: '/b2b/account/resetPassword',
      method: 'post',
      data
    })
  },
}

/**
 * @description [ merchantCategory ] 代理商充值接口相关
 */
export const agentRecharge = {
	agentRechargegetList(data) {
	  return request({
	    url: '/b2b/agentRecharge/getList',
	    method: 'post',
	    data
	  })
	},
	rechargeApply(data) {
	  return request({
	    url: '/b2b/agentRecharge/rechargeApply',
	    method: 'post',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    data
	  })
	},
	rechargeModify(data) {
	  return request({
	    url: '/b2b/agentRecharge/rechargeModify',
	    method: 'post',
	    data
	  })
	},
	airlinelist(data) {
	  return request({
	    url: '/b2b/airline/list',
	    method: 'post',
	    data
	  })
	},
	airlineairports(data) {
	  return request({
	    url: '/b2b/airline/airports',
	    method: 'post',
	    data
	  })
	},
	getAgentWalletRecordList(data) {
	  return request({
	    url: '/b2b/account/getAgentWalletRecordList',
	    method: 'post',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    data
	  })
	},
	getList(data) {
	  return request({
	    url: '/b2b/agent/getList',
	    method: 'post',
	    data
	  })
	},
	getOneByPk(data) {
	  return request({
	    url: '/b2b/agent/getOneByPk',
	    method: 'post',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    data
	  })
	},
	walletgetAgentWalletRecordList(data) {
	  return request({
	    url: '/b2b/wallet/getAgentWalletRecordList',
	    method: 'post',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    data
	  })
	},
	editMainAgent(data) {
	  return request({
	    url: '/b2b/agent/editSubAgent',
	    method: 'post',
	    data
	  })
	},
	createMainAgent(data) {
	  return request({
	    url: '/b2b/agent/createSubAgent',
	    method: 'post',
	    data
	  })
	},
	getListWithRelation(data) {
	  return request({
	    url: '/b2b/Role/getListWithRelation',
	    method: 'post',
	    data
	  })
	},
	doRecharge(data) {
	  return request({
	    url: '/b2b/agentRecharge/doRecharge',
	    method: 'post',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    data
	  })
	},
	b2bagentinfo(data) {
	  return request({
	    url: '/b2b/agent/info',
	    method: 'post',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    data
	  })
	},
	getAgentArilineCabin(data) {
	  return request({
	    url: '/b2b/airline/getAgentArilineCabin',
	    method: 'post',
	    data
	  })
	},
	airlineavailability(data) {
	  return request({
	    url: '/b2b/airline/availability',
	    method: 'post',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    data
	  })
	},
}
/**
 * @description [ merchantCategory ] 管理员创建代理商
 */
export const managerAgentControl = {
	createMainAgent(data) {
	  return request({
	    url: '/manager/Agent/createMainAgent',
	    method: 'post',
	    data
	  })
	},
	getList(data) {
	  return request({
	    url: '/manager/Agent/getList',
	    method: 'post',
	    data
	  })
	},
	Agentinfo(data) {
	  return request({
	    url: '/manager/Agent/info',
	    method: 'post',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    data
	  })
	},
	nationalitygetList(data) {
	  return request({
	    url: '/common/nationality/getList',
	    method: 'post',
	    data
	  })
	},
	editMainAgent(data) {
	  return request({
	    url: '/manager/Agent/editMainAgent',
	    method: 'post',
	    data
	  })
	},
	setDiscountRate(data) {
	  return request({
	    url: '/manager/Agent/setDiscountRate',
	    method: 'post',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    data
	  })
	},
	getOneByPk(data) {
	  return request({
	    url: '/manager/Agent/getOneByPk',
	    method: 'post',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    data
	  })
	},
	AgentgetOne(data) {
	  return request({
	    url: '/manager/Agent/getOne',
	    method: 'post',
	    data
	  })
	},
	doRecharge(data) {
	  return request({
	    url: '/manager/agentRecharge/doRecharge',
	    method: 'post',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    data
	  })
	},
	agentRechargegetList(data) {
	  return request({
	    url: '/manager/agentRecharge/getList',
	    method: 'post',
	    data
	  })
	},
	walletgetAgentWalletRecordList(data) {
	  return request({
	    url: '/manager/wallet/getAgentWalletRecordList',
	    method: 'post',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    data
	  })
	},
	transferIn(data) {
	  return request({
	    url: '/manager/agentTransfer/transferIn',
	    method: 'post',
	    data
	  })
	},
	transferOut(data) {
	  return request({
	    url: '/manager/agentTransfer/transferOut',
	    method: 'post',
	    data
	  })
	},
	BtransferIn(data) {
	  return request({
	    url: '/b2b/agentTransfer/transferIn',
	    method: 'post',
	    data
	  })
	},
	BtransferOut(data) {
	  return request({
	    url: '/b2b/agentTransfer/transferOut',
	    method: 'post',
	    data
	  })
	},
	airlinelist(data) {
	  return request({
	    url: '/manager/airline/list',
	    method: 'post',
	    data
	  })
	},
	agentAirlineBinding(data) {
		  return request({
		    url: '/manager/AgentAirline/agentAirlineBinding',
		    method: 'post',
		    data
		  })
		},
	getAgentAirlineBinding(data) {
		return request({
		    url: '/manager/AgentAirline/getAgentAirlineBinding?agentId='+data.agentId,
		    method: 'post',
		    
		})
	},
	setLimitSales(data) {
	  return request({
	    url: '/manager/Agent/setLimitSales',
	    method: 'post',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    data
	  })
	},
}
/**
 * @description [ merchantCategory ] 官网管理
 */
export const officialManagement = {
	ArticlegetList(data) {
	  return request({
	    url: '/manager/article/getListAll',
	    method: 'post',
	    data
	  })
	},
	ArticleupdateData(data) {
	  return request({
	    url: '/manager/article/updateData',
	    method: 'post',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    data
	  })
	},
	Articlecreate(data) {
	  return request({
	    url: '/manager/article/create',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
	    data
	  })
	},
	MultiTextdoSave(data) {
	  return request({
	    url: '/manager/MultiText/doSave',
	    method: 'post',
	    data
	  })
	},
	ArticlechangeHot(data) {
	  return request({
	    url: '/manager/article/changeHot',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
	    data
	  })
	},
	ArticlechangeStatus(data) {
	  return request({
	    url: '/manager/article/changeStatus',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
	    data
	  })
	},
	ArticledeleteOne(data) {
	  return request({
	    url: '/manager/article/deleteOne',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
	    data
	  })
	},
	CarouselgetCarousel(data) {
	  return request({
	    url: '/manager/Carousel/getCarousel',
	    method: 'post',
	    data
	  })
	},
	addAdvert(data) {
	  return request({
	    url: '/manager/Advert/addAdvert',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
	    data
	  })
	},
	modifyAdvert(data) {
	  return request({
	    url: '/manager/Advert/modifyAdvert',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
	    data
	  })
	},
	addCarousel(data) {
	  return request({
	    url: '/manager/Carousel/addCarousel',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
	    data
	  })
	},
	modifyCarousel(data) {
	  return request({
	    url: '/manager/Carousel/modifyCarousel',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
	    data
	  })
	},
	deleteCarousel(data) {
	  return request({
	    url: '/manager/Carousel/deleteCarousel',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
	    data
	  })
	},
}
/**
 * @description [ merchantCategory ] 订单管理
 */
export const orderManagement={
	b2bbookinglist(data) {
	  return request({
	    url: '/b2b/flight/booking/listComp',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
	    data
	  })
	},
	corderlist(data) {
	  return request({
	    url: '/manager/2c/order/listComp',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
	    data
	  })
	},
	Corderdetail(data) {
	  return request({
	    url: '/manager/2c/order/detail',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
	    data
	  })
	},
	Borderlist(data) {
	  return request({
	    url: '/manager/2b/order/listComp',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
	    data
	  })
	},
	Borderdetail(data) {
	  return request({
	    url: '/manager/2b/order/detail',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
	    data
	  })
	},
	Crefundlist(data) {
	  return request({
	    url: '/manager/2c/refund/list',
	    method: 'post',
	    data
	  })
	},
	Crefundcreate(data) {
	  return request({
	    url: '/manager/2c/refund/create',
	    method: 'post',
	    data
	  })
	},
	Crefundconfirm(data) {
	  return request({
	    url: '/manager/2c/refund/confirm',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
	    data
	  })
	},
	Crefundrefuse(data) {
	  return request({
	    url: '/manager/2c/refund/refuse',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
	    data
	  })
	},
	Brefundlist(data) {
	  return request({
	    url: '/manager/2b/refund/list',
	    method: 'post',
	    data
	  })
	},
	Brefundrefuse(data) {
	  return request({
	    url: '/manager/2b/refund/refuse',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
	    data
	  })
	},
	Brefundconfirm(data) {
	  return request({
	    url: '/manager/2b/refund/confirm',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
	    data
	  })
	},
	Capproveapprove(data) {
	  return request({
	    url: '/manager/2c/refund/approve',
	    method: 'post',
	    data
	  })
	},
	BticketRefundInter(data) {
	  return request({
	    url: '/manager/2b/refund/ticketRefundInter?refundOrderId=' + data.refundOrderId,
	    method: 'post',
	  })
	},
	Brefundcreate(data) {
	  return request({
	    url: '/manager/2b/refund/create',
	    method: 'post',
		data
	  })
	},
	Bflightemail(data) {
	  return request({
	    url: '/b2b/flight/email',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
		data
	  })
	},
	Bflightexport(data) {
	  return request({
	    url: '/b2b/flight/export?pnr=' + data.pnr,
	    method: 'get',
	  })
	},
	CticketRefundInter(data) {
	  return request({
	    url: '/manager/2c/refund/ticketRefundInter?refundOrderId=' + data.refundOrderId,
	    method: 'post',
	  })
	},
	Corderemail(data) {
	  return request({
	    url: '/manager/2c/order/email',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
	    data
	  })
	},
	Borderemail(data) {
	  return request({
	    url: '/manager/2b/order/email',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
	    data
	  })
	},
	corderexport(data) {
	  return request({
	    url: '/manager/2c/order/export',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
		responseType: 'blob',
	    data
	  })
	},
	borderexport(data) {
	  return request({
	    url: '/manager/2b/order/export',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
		responseType: 'blob',
	    data
	  })
	},
	b2bflightexport(data) {
	  return request({
	    url: '/b2b/flight/export',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
		responseType: 'blob',
	    data
	  })
	},
	tocemailedit(data) {
	  return request({
	    url: '/manager/2c/order/email/edit',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
	    data
	  })
	},
}
/**
 * @description [ placeAnOrder ] 下单相关
 */
export const placeAnOrder={ 
	nationalityCode(data) {
	  return request({
	    url: '/api/common/nationalityCode',
	    method: 'post',
	    data
	  })
	},
	travelTax(data) {
	  return request({
	    url: '/api/common/travelTax',
	    method: 'post',
	    data
	  })
	},
	getMyLimitSales(data) {
	  return request({
	    url: '/b2b/agent/getMyLimitSales',
	    method: 'post',
	    data
	  })
	},
	getRebookPrice(data) {
	  return request({
	    url: '/b2b/flight/getRebookPrice',
	    method: 'post',
	    data
	  })
	},
	createRebooking(data) {
	  return request({
	    url: '/b2b/flight/createRebooking',
	    method: 'post',
	    data
	  })
	},
}
/**
 * @description [ placeAnOrder ] 下单相关
 */
export const reportOrder={ 
	orderlist(data) {
	  return request({
	    url: '/manager/report/order/list',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
	    data
	  })
	},
	orderexport(data) {
	  return request({
	    url: '/manager/report/order/export',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
	    data
	  })
	},
	passengerorderlist(data) {
	  return request({
	    url: '/manager/report/passenger/order/list',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
	    data
	  })
	},
	baggageorderlist(data) {
	  return request({
	    url: '/manager/report/baggage/order/list',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
	    data
	  })
	},
	reportexport(data) {
	  return request({
	    url: '/manager/report/order/export',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
		responseType: 'blob',
	    data
	  })
	},
	passengerexport(data) {
	  return request({
	    url: '/manager/report/passenger/order/export',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
		responseType: 'blob',
	    data
	  })
	},
	baggageexport(data) {
	  return request({
	    url: '/manager/report/baggage/order/export',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
		responseType: 'blob',
	    data
	  })
	},
	travelTaxlist(data) {
	  return request({
	    url: '/manager/report/travelTax/order/list',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
	    data
	  })
	},
	travelTaxexport(data) {
	  return request({
	    url: '/manager/report/travelTax/order/export',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
		responseType: 'blob',
	    data
	  })
	},
	paxexport(data) {
	  return request({
	    url: '/manager/report/pax/export',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
		responseType: 'blob',
		timeout: 1200000,
	    data
	  })
	},
	refexport(data) {
	  return request({
	    url: '/manager/finance/report/ref/export',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
		responseType: 'blob',
		timeout: 1200000,
	    data
	  })
	},
	saleexport(data) {
	  return request({
	    url: '/manager/finance/report/sale/export',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
		responseType: 'blob',
		timeout: 1200000,
	    data
	  })
	},
	uplexport(data) {
	  return request({
	    url: '/manager/finance/report/upl/export',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
		responseType: 'blob',
		timeout: 1200000,
	    data
	  })
	},
	noshowexport(data) {
	  return request({
	    url: '/manager/finance/report/noshow/export',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
		responseType: 'blob',
		timeout: 1200000,
	    data
	  })
	},
	undefinedexport(data) {
	  return request({
	    url: '/manager/finance/report/undefined/export',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
		responseType: 'blob',
		timeout: 1200000,
	    data
	  })
	},
	reportemdlist(data) {
	  return request({
	    url: '/manager/report/emd/list',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
	    data
	  })
	},
	reportemdexport(data) {
	  return request({
	    url: '/manager/report/emd/export',
		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    method: 'post',
		responseType: 'blob',
	    data
	  })
	},
}